<!-- ✅ Global header: shown on every page -->
<app-header *ngIf="isAccessProvided"></app-header>

<!-- 👇 Routed components will be shown here -->
<router-outlet *ngIf="isAccessProvided"></router-outlet>
<app-notification [notification]="notification"></app-notification>